import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const InvestorAccess = ({ onRequestAccess, onScrollContact }) => {
  return (
    <section
      id="investor-access"
      data-testid={LANDING.investorAccess}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)] kr-atmosphere"
      style={{ background: "var(--kr-bg-2)" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <SectionHeading
              index="19"
              label="Investor Access"
              title={
                <>
                  Engage with the{" "}
                  <span className="italic text-[var(--kr-gold)]">
                    partnership
                  </span>
                  .
                </>
              }
            />
          </div>
          <div className="lg:col-span-7 lg:pl-10">
            <p className="text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[64ch] mb-6">
              Kellermann Reid &amp; Co. is in a selective engagement phase with
              strategic capital partners, placement agents, family offices,
              seed investors and institutional counterparties. Access to
              detailed materials is reserved for eligible, sophisticated,
              professional or institutional investors and is provided only
              following appropriate review.
            </p>
            <p className="text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[64ch] mb-12">
              To initiate a confidential dialogue, please submit an investor
              access request. Any further information will be shared only where
              appropriate and subject to applicable legal, regulatory and
              documentation requirements.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
                type="button"
                onClick={onRequestAccess}
                data-testid={LANDING.investorRequestAccess}
                className="kr-btn-primary"
              >
                Request Investor Access
                <span aria-hidden>→</span>
              </button>
              <button
                type="button"
                onClick={onScrollContact}
                data-testid={LANDING.investorGeneralEnquiry}
                className="kr-btn-ghost"
              >
                General Enquiry
              </button>
              <button
                type="button"
                onClick={() => onRequestAccess({ interest: "strategic" })}
                data-testid={LANDING.investorStrategic}
                className="kr-btn-ghost"
              >
                Discuss Strategic Partnership
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestorAccess;
